var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.142,11.849L7.609,11.837L15.176,4.299C15.473,4 15.636,3.603 15.636,3.181C15.636,2.759 15.473,2.362 15.176,2.064L13.93,0.81C13.336,0.213 12.3,0.216 11.711,0.808L4.142,8.348L4.142,11.849ZM12.819,1.928L14.068,3.179L12.813,4.429L11.567,3.176L12.819,1.928ZM5.714,9.007L10.451,4.287L11.697,5.541L6.96,10.259L5.714,10.263L5.714,9.007Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.571,15L13.57,15C14.436,15 15.141,14.291 15.141,13.419L15.141,6.57L13.57,8.15L13.57,13.419L5.052,13.419C5.032,13.419 5.01,13.427 4.99,13.427C4.964,13.427 4.938,13.42 4.912,13.419L2.571,13.419L2.571,2.356L7.95,2.356L9.521,0.776L2.571,0.776C1.705,0.776 1,1.484 1,2.356L1,13.419C1,14.291 1.705,15 2.571,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cb63226f18a794479c530c2107cb240e.svg";
export { ForwardRef as ReactComponent };